import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
    GetPracticeTypesResponse,
    PracticeTypeActions,
    PracticeTypeActionTypes,
} from '../../actions/mdqx/practice-type.actions';
import { HttpService } from '../../../services/http.service';
import { PracticeTypeEntity } from '../../../entities/mdqx/practice-type.entity';
import { BaseActionTypes } from '../../actions/base.actions';
import { State } from '../../index';
import { getToken } from '../../selectors/base.selectors';
import { environment } from '../../../../../environments/environment';
enum ErrorCodes {
    Get = 'Praxistypen Abrufen fehlgeschlagen',
}

@Injectable()
export class PracticeTypeEffects {
    
    getPracticeTypes$ = createEffect(() => this.actions$.pipe(
        ofType(PracticeTypeActionTypes.GetPracticeTypesRequest),
        map(
            () => `
            {
                practiceTypes {
                    ${PracticeTypeEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({ query }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                map(res => res && res.practiceTypes),
                concatMap(res =>
                    res
                        ? [
                              new GetPracticeTypesResponse(
                                  res.map(practiceType => new PracticeTypeEntity(practiceType)),
                              ),
                          ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions<PracticeTypeActions>,
        private api: HttpService,
        private store: Store<State>,
    ) {}
}
